// not MUI breakpoints
export const DEVICES = {
  xxs: 320,
  xs: 481,
  s: 641,
  m: 961,
  l: 1025,
  xl: 1281,
};

export const MAP_HEIGHT = {
  default: 'calc(100vh - 188px)',
  upSmall: 'calc(100vh - 196px)',
  upMedium: 'calc(100vh - 138px)',
};
